export default "__VITE_ASSET__Bxu0ZGhE__";